import { useEffect, useState } from "react";
import { Outlet, useLocation, Link } from "react-router-dom";
import Lenis from "lenis";
import { Phone } from "lucide-react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { CookieBanner, readConsent } from "./CookieBanner";
import { SITE } from "@/config/site";

export const Layout = () => {
  const { pathname, hash } = useLocation();
  const [cookiesOpen, setCookiesOpen] = useState(() => readConsent() === null);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) { setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 50); return; }
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);

  return (
    <div className="App flex flex-col min-h-screen">
      <a href="#main" className="skip-link" data-testid="skip-link">Aller au contenu principal</a>
      <Header />
      <main id="main" className="flex-1">
        <Outlet />
      </main>
      <Footer onManageCookies={() => setCookiesOpen(true)} />
      <CookieBanner open={cookiesOpen} onClose={() => setCookiesOpen(false)} />
      <div className="fixed bottom-4 left-4 right-4 z-40 lg:hidden flex gap-2 pointer-events-none" aria-hidden={cookiesOpen}>
        {!cookiesOpen && pathname !== "/contact" && (
          <>
            <Link to="/contact" className="btn-primary flex-1 pointer-events-auto shadow-xl" data-testid="sticky-devis-cta">Devis gratuit</Link>
            <a href={SITE.phone.href} className="btn-dark pointer-events-auto shadow-xl !px-4" aria-label="Appeler" data-testid="sticky-phone-cta"><Phone size={18} /></a>
          </>
        )}
      </div>
    </div>
  );
};
